import React from 'react'
import { ThemeProvider, CssBaseline, Typography} from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2';
import {theme} from '../theme.js'
import { TopBar } from '../components/TopBar/TopBar'
import {Footer} from '../components/Footer/Footer'
import {ControlledAccordions} from '../components/Accordion/Accordion'
import faq from '../images/faq.jpg'
import tiling from '../images/blue-tile.png'
export const Live = () => {
  return (
    
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      <Grid container spacing={0} style={{backgroundImage:`url(${tiling})`, backgroundAttachment:"fixed"}}>
        <Grid item xs={12}>
          <TopBar/>
        </Grid>
        <Grid item xs={12} paddingTop={8}>
          <Typography variant = "h1"color="white" justifyContent="center" display="flex">
            COMING SOON!!!
          </Typography>
        </Grid>
      <Footer/>
      </Grid>
    </ThemeProvider>
    )
}
